import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';
import config from '../config';

import {
  AUTH_USER_SET_DATA,
  AUTH_USER_RESET_DATA
} from '../actions/auth-user/types';

export function initAnalytics() {
  const trackingId = config.ga.trackingId;

  log(`[GA] Initialize and track ${trackingId}`);

  GoogleAnalytics.initialize(trackingId, {
    debug: config.ga.debug,
    titleCase: false
  });
}

export function trackAnalyticsComponentWrapper(WrappedComponent) {
  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPageView(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPageView(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
}

export const trackAnalyticsReduxMiddleware = store => next => action => {
  const actionResult = next(action);

  const state = store.getState();
  const { authUser } = state;
  const userId = authUser && authUser.get('userId');

  switch (action.type) {
    case AUTH_USER_SET_DATA:
      setUserInAnalytics(userId);
      break;

    case AUTH_USER_RESET_DATA:
      clearUserInAnalytics();
      break;

    default:
      break;
  }

  return actionResult;
};

function trackPageView(page) {
  log(`[GA] Start tracking page ${page}`);

  GoogleAnalytics.set({ page });
  GoogleAnalytics.pageview(page);
}

function setUserInAnalytics(userId) {
  log(`[GA] set user ${userId}`);

  GoogleAnalytics.set({ userId: userId });
}

function clearUserInAnalytics() {
  log(`[GA] clear user`);

  GoogleAnalytics.set({ userId: '' });
}

function log() {
  if (!config.ga.logEnabled) {
    return;
  }

  console.log(...arguments);
}



// WEBPACK FOOTER //
// ./src/tools/google-analytics.js